import React, {useContext} from "react";
import * as Const from "../Const";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {SessionContext} from "../context/SessionContextProvider";
import {BASE_NAME, SHOW_UNFINISHED_STUFF} from "../Const";
import {Button} from "react-bootstrap";


function UserHeader(props) {

    const navigation = useNavigate();
    const { session, updateSession } = useContext(SessionContext);


    function handleLogout() {
        axios.delete(Const.API_CLOUD_USERS_AUTH)
            .then(res => {
                // localStorage.removeItem(Const.COOKIE_SESSION);
                updateSession(null);
                navigation(BASE_NAME + "/user/login");
            });
    }


    return (
        <div className={"card shadow-lg"}>
            <div className={"card-header"}>
                {props.userId === 0 ? "not logged in" : props.userName}
                {SHOW_UNFINISHED_STUFF ?
                    <>({props.userId}) {props.remoteAddr}</>
                    : null
                }
                <button className={"btn btn-secondary mx-3"} onClick={handleLogout}>Log out</button>
            </div>
            {Const.SHOW_UNFINISHED_STUFF ?
                <div className={"card-body d-flex align-items-center"}>
                    <Button className={"mx-1"} as="a" href={BASE_NAME + "/map"}>Map</Button>
                    <Button className={"mx-1"} as="a" href={BASE_NAME + "/user/home"}>Home</Button>
                    <Button className={"mx-1"} as="a" href={BASE_NAME + "/rain"}>Rain Rover</Button>
                {/*    <div className={"col-6"}>*/}
                {/*        /!*<div className={""}>{props.userId > 0 ? "logged in" : "not logged in"} {props.userId}: {props.userName} {props.remoteAddr}</div>*!/*/}
                {/*        /!*<div style={{color: "#bbb"}}>{session}</div>*!/*/}
                {/*    </div>*/}
                {/*    <div className={"col-6"}>*/}
                {/*    </div>*/}
                </div>
                : null
            }
        </div>
    );

}


export default UserHeader;
